module.exports = __webpack_public_path__ + "static/media/mana.b57be103.svg";